<template>
    <div class="ag-page_assets position-relative">
        <div class="ag-content ag-card">
            <div class="ag-card_header d-flex align-items-center">
                <div class="ag-card_navigation">
                    <ul class="nav">
                        <li class="nav-item d-flex align-items-center">
                            <a aria-current="page" href="#" v-if="!templatePolicy" class=" router-link-active router-link-exact-active
                            nav-item
                            pt-3
                            pb-3
                            pl-4
                            pr-4
                            d-block d-flex
                            align-items-center
                            active ">
                                {{ $t("site") }}:&nbsp; <span class="italic">{{ this.site.site }}</span> &nbsp;|
                                &nbsp;{{
                                $t("group") }}:
                                &nbsp;<span class="italic">{{
                                this.group?.group }}</span> &nbsp;| &nbsp;{{ $t("rolePolicy") }}:&nbsp;
                                <span class="italic">{{ this.template }}</span>

                            </a>
                            <a aria-current="page" href="#" v-else class=" router-link-active router-link-exact-active
                            nav-item
                            pt-3
                            pb-3
                            pl-4
                            pr-4
                            d-block d-flex
                            align-items-center
                            active ">
                                {{ $t("rolePolicy") }}: &nbsp;<span class="italic">{{ this.template }}</span>

                            </a>
                        </li>
                    </ul>
                </div>
                <div class="ag-card_buttons d-flex ml-auto mr-3" style="width: 15rem;">
                    <div class="input-group">
                        <span class="input-group-prepend">
                            <div class="input-group-text bg-transparent border-right-0">
                                <i class="ag-icon ag-icon_darkSearch"></i>
                            </div>
                        </span>
                        <input class="form-control py-2 border-left-0 border" v-model="globalSearch" type="search"
                            placeholder="Search..." />
                    </div>
                </div>
                <div class="ag-card_buttons d-flex">
                    <a class="
              ag-button
              btn-sm
              ml-2
              d-inline-flex
              align-items-center
              ag-button_primary
              mr-3" style="cursor: pointer;" @click="expandCollapse">
                        <i :class="expanded ? 'ag-icon mr-1 ag-icon_collapse' : 'ag-icon mr-1 ag-icon_expand2'"></i> {{
                                expanded ? $t("collapse") : $t("expandAll") }}
                    </a>
                    <a class="
              ag-button
              btn-sm
              ml-2
              d-inline-flex
              align-items-center
              ag-button_primary
              mr-3
            " style="cursor: pointer;" @click="addRule">
                        <i class="ag-icon mr-1 ag-icon_add"></i> {{ $t("addRule") }}
                    </a>

                </div>
            </div>
            <div class="ag-card_body">
                <ag-loading v-if="loading" class="ag-loading" />
                <div v-if="!loading" class="m-3">
                    <div v-if="isCreateIgnoreEventVisible" class="modal">
                        <ag-create-ignore-event ref="createIgnoreEvent" @close-popup="closeCreateIgnoreEventPopup"
                            @update-success="handleUpdateSuccess" @ignore-event-updated="handleIgnoreEventUpdated" />
                    </div>
                    <DataTable v-model:expandedRows="expandedRows" paginator selectionMode="single" ref="dataTable"
                        @row-click="toggleRow($event)" :rows="rowsPerPage" :value="filteredRules" dataKey="id"
                        size="small" :currentPage="currentPage" :rowsPerPageOptions="[5, 10, 20, 50]"
                        paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="{totalRecords} Results" :pt="{
                                column: {
                                    bodycell: ({ state }) => ({
                                        style: 'background-color:#F9FAFB;'
                                    })
                                }
                            }">

                        <Column expander style="width: 5rem" headerStyle="display:none" />
                        <Column field="ruleName" header="Rule Name" headerStyle="display:none">
                            <template #body="slotProps">
                                {{ slotProps.data.conditions.length > 0 ? slotProps.data.conditions[0].elementCategory :
                                ''
                                }} | {{ slotProps.data.ruleName }}
                            </template>
                        </Column>
                        <Column headerStyle="width:1rem;display:none" style="width: 5rem">
                            <template #body="slotProps">
                                <Button @click="openCreateIgnoreEventPopup(slotProps.data, false)"
                                    icon="ag-icon ag-icon_edit" class="icon" size="small" :title="$t('editRule')"
                                    outlined />
                            </template>
                        </Column>
                        <Column headerStyle="width:1rem;display:none" style="width: 5rem">
                            <template #body="slotProps">
                                <Button @click="openCreateIgnoreEventPopup(slotProps.data, true)"
                                    icon="ag-icon ag-icon_copy" class="icon" size="small" :title="$t('duplicateRule')"
                                    outlined />
                            </template>
                        </Column>
                        <Column headerStyle="width:1rem;display:none" style="width: 5rem">
                            <template #body="slotProps">
                                <Button @click="removeRule(slotProps.data)" icon="ag-icon ag-icon_delete"
                                    class="delete-icon" :title="$t('deleteRule')" outlined />
                            </template>
                        </Column>
                        <template #expansion="slotProps">
                            <div>
                                <DataTable :value="slotProps.data.conditions">
                                    <Column field="elementName" :header="$t('elementName')" headerStyle="width:25rem">
                                    </Column>
                                    <Column field="condition" :header="$t('condition')" headerStyle="width:25rem">
                                        <template #body="slotProps">
                                            {{ slotProps.data.conditionFormatted }}
                                        </template>
                                    </Column>
                                    <Column field="value" :header="$t('value')"></Column>
                                    <Column field="level" :header="$t('level')" headerStyle="width:5rem">
                                        <template #body="slotProps">
                                            {{ slotProps.data.levelFormatted }}
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </template>
                        <template #empty>
                            <div class="text-center mt-3">
                                <p>{{ $t("noRulesFound") }}</p>
                            </div>
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from "@/store";
import AgLoading from "@/components/ag-loading/index.vue";
import axios from "axios";
import { ref, onMounted } from 'vue';
import { mapState, mapGetters } from "vuex";
import { notify } from "@kyvg/vue3-notification";
import api from "@/api/index";
import AgCreateIgnoreEvent from "@/components/ag-overall/components/ag-create-ignore-event.vue";
import axiosAgsc from "@/store/axiosAgsc";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';

const store = useStore();
// const group = store.getters.group;

let requestModel = {};
let groupString = localStorage.getItem("agms_group");
let group = JSON.parse(groupString);
let res = "";

export default {
    components: {
        AgCreateIgnoreEvent,
        AgLoading,
    },

    computed: {
        filteredRules() {
            const globalSearchTerm = this.globalSearch ? this.globalSearch.toLowerCase() : '';

            return this.templatePolicy
                ? this.templateRequestBody.ignoreEvents.rules.filter(rule =>
                    this.filterRule(rule, globalSearchTerm)
                )
                : this.groupRequestBody.ignoreEvents.rules.filter(rule =>
                    this.filterRule(rule, globalSearchTerm)
                );
        },
        ...mapState({
            agmsCompany: (state) => state.auth.company,
            agmsGroup: (state) => state.auth.agmsGroup,
            agmsSite: (state) => state.auth.agmsSite,
            agmsTemplate: (state) => state.auth.agmsTemplate,
        }),
        ...mapGetters(["loggedInUser"]),
    },
    data() {
        return {
            loading: true,
            isCreateIgnoreEventVisible: false,
            tableData: [],
            apiConditions: [],
            apiProperties: [],
            apiLevels: [],
            apiPublisherLevels: [],
            currentLevels: [],
            template: '',
            templateId: 0,
            groupRequestBody: {},
            templateRequestBody: {},
            group: null,
            site: {},
            role: null,
            expandedRows: ref([]),
            templatePolicy: false,
            expanded: false,
            globalSearch: null,
            currentPage: 1,
            rowsPerPage: 20,
        };
    },

    async created() {
        const routeName = this.$route.name;
        if (routeName == 'templateIgnoreEvents') {
            this.templatePolicy = true;
            await this.getTemplateList();
        } else {
            await this.getPolicyList();
        }

        this.group = JSON.parse(localStorage.getItem("agms_group")) || {};
        this.site = JSON.parse(localStorage.getItem("agms_site")) || {};
    },

    methods: {
        addRule() {
            this.openCreateIgnoreEventPopup(null, true);
        },

        closeCreateIgnoreEventPopup() {
            this.isCreateIgnoreEventVisible = false;
        },

        filterRule(rule, searchTerm) {
            const lowerCaseSearchTerm = searchTerm ? searchTerm.toLowerCase() : '';

            return (
                rule.ruleName.toLowerCase().includes(lowerCaseSearchTerm) ||
                rule.conditions.some(condition =>
                    (condition.elementName && condition.elementName.toLowerCase().includes(lowerCaseSearchTerm)) ||
                    (condition.value && condition.value.toLowerCase().includes(lowerCaseSearchTerm)) ||
                    (condition.elementCategory && condition.elementCategory.toLowerCase().includes(lowerCaseSearchTerm))
                )
            );
        },

        async deleteRule(rule) {
            let url = this.templatePolicy ? `agms/TemplatePolicy/DeleteIgnoreEventFilterRule` : `agms/IgnoreEvents/DeleteIgnoreEventFilterRule`

            const requestModel = {
                ID: rule.id,
                IgnoreEventsId: rule.ignoreEventsId,
                TemplateId: this.templatePolicy ? JSON.parse(localStorage.getItem("agms_template")).mainid : null,
                RuleName: rule.ruleName,
                Conditions: rule.conditions.map((condition) => ({
                    ID: condition.id,
                    RuleId: condition.ruleId,
                    ElementCategory: condition.elementCategory,
                    ElementName: condition.elementName,
                    Condition: condition.condition,
                    Value: condition.value,
                    Level: condition.level,
                })),
            };
            this.loading = false;
            axiosAgsc.post(url, requestModel)
                .then((response) => {
                    if (response.data.statusCode == 200 && response.data.isSuccess == true) {
                        if (!this.templatePolicy) {
                            this.getPolicyList();
                        } else {
                            this.getTemplateList();
                        }
                        notify({
                            title: this.$t("ignoreEventDeleted"),
                            type: "success",
                            duration: 4000,
                        });
                    } else {
                        notify({
                            title: this.$t("error"),
                            type: "error",
                            text: response.data.message,
                            duration: 8000,
                        });
                    }
                })
                .catch((error) => {
                    notify({
                        title: this.$t("error"),
                        type: "error",
                        text: error,
                        duration: 8000,
                    });
                });
        },

        expandCollapse() {
            if (this.expanded) {
                this.expandedRows = null;
                this.expanded = false;
            }
            else {
                let rules = this.templatePolicy ? this.templateRequestBody.ignoreEvents.rules : this.groupRequestBody.ignoreEvents.rules;
                this.expandedRows = rules.reduce((acc, p) => (acc[p.id] = true) && acc, {});
                this.expanded = true;
            }
        },

        async getPolicyList() {
            try {
                let url = `agms/IgnoreEvents/GetIgnoreEventList?mainId=${group.mainid}`
                res = await axiosAgsc.get(url);
                const groupViewModel = res.data.entityData;
                this.apiConditions = groupViewModel.conditions || [];
                this.apiProperties = groupViewModel.elementNames || [];
                this.apiLevels = groupViewModel.positions || [];
                this.apiPublisherLevels = groupViewModel.publisherPositions || [];
                this.groupRequestBody = groupViewModel.groupPolicyViewModel;
                this.template = groupViewModel.templateType;
                this.groupRequestBody.ignoreEvents.rules.forEach(rule => {
                    rule.conditions.forEach(condition => {
                        condition.conditionFormatted = this.getFormattedCondition(condition.condition);
                        condition.levelFormatted = this.getFormattedLevel(condition.level, condition.elementName);
                    });
                });
                setTimeout(() => {
                    this.loading = false;
                }, 350);
            } catch (error) {
                console.error('Error:', error);
                this.loading = false;
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            }
        },

        getFormattedCondition(condition) {
            const conditionObject = this.apiConditions.find(apiCondition => apiCondition.value === condition);

            if (conditionObject) {
                return conditionObject.text || condition;
            }

            return condition;
        },

        getFormattedLevel(level, elementName) {
            if (elementName.includes('ancestors.ancestor')) {
                const formattedLevels = ['Process', 'Parent', 'GrandParent'];

                return level === -1 ? 'Any' : formattedLevels[level] || 'All';

            } else if (elementName.includes('publishers.publisher')) {
                const formattedLevels = [this.apiPublisherLevels[0], this.apiPublisherLevels[2], this.apiPublisherLevels[3], this.apiPublisherLevels[4]];

                return level === -1 ? 'Any Certificates' : formattedLevels[level].text || 'All';
            }

            return level;
        },

        async getTemplateList() {
            try {
                let templateId = JSON.parse(localStorage.getItem("agms_template")).mainid;
                let url = `agms/TemplatePolicy/GetTemplateIgnoreEventList?templateId=${templateId}`;
                res = await axiosAgsc.get(url);
                const groupViewModel = res.data.entityData;
                this.apiConditions = groupViewModel.conditions || [];
                this.apiProperties = groupViewModel.elementNames || [];
                this.apiLevels = groupViewModel.positions || [];
                this.apiPublisherLevels = groupViewModel.publisherPositions || [];
                this.template = groupViewModel.templateType;
                this.templateRequestBody = groupViewModel.templatePolicyViewModel;
                this.templateRequestBody.ignoreEvents.rules.forEach(rule => {
                    rule.conditions.forEach(condition => {
                        condition.conditionFormatted = this.getFormattedCondition(condition.condition);
                        condition.levelFormatted = this.getFormattedLevel(condition.level, condition.elementName);
                    });
                });
                setTimeout(() => {
                    this.loading = false;
                }, 350);
            } catch (error) {
                console.error('Error:', error);
                this.loading = false;
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            }
        },

        async handleIgnoreEventUpdated() {
            return this.templatePolicy ? await this.getTemplateList() : await this.getPolicyList();
        },

        openCreateIgnoreEventPopup(rule, isDuplicate = false) {
            this.isCreateIgnoreEventVisible = true;
            const type = this.templatePolicy ? JSON.parse(localStorage.getItem("agms_template")).mainid : group;

            this.$nextTick(() => {
                const createIgnoreEventComponent = this.$refs.createIgnoreEvent;

                if (createIgnoreEventComponent) {
                    if (this.templatePolicy) {
                        if (isDuplicate) {
                            createIgnoreEventComponent.duplicateRule(rule, this.templatePolicy, type, this.templateRequestBody);
                        } else {
                            createIgnoreEventComponent.setRuleAndConditions(rule, this.templatePolicy, type, this.templateRequestBody);
                        }
                    } else {
                        if (isDuplicate) {
                            createIgnoreEventComponent.duplicateRule(rule, this.templatePolicy, type, this.groupRequestBody);
                        } else {
                            createIgnoreEventComponent.setRuleAndConditions(rule, this.templatePolicy, type, this.groupRequestBody);
                        }
                    }
                } else {
                    console.error("Ref createIgnoreEvent not found");
                }
            });
        },

        removeRule(rule) {
            this.$swal
                .fire({
                    title: this.$t('areYouSure'),
                    icon: "warning",
                    text: this.$t('ignoreEventsRemoveRule'),
                    showCancelButton: true,
                    confirmButtonText: "Delete",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.loading = true;
                        this.deleteRule(rule);
                    }
                })
        },

        toggleRow(event) {

            if (event.originalEvent.srcElement.tagName == "TD") {
                const rowData = event.data;
                let expandedRows;

                expandedRows = this.expandedRows ? { ...this.expandedRows } : {};
                let expanded = expandedRows[rowData.id] == undefined ? false : true;

                expanded ? delete expandedRows[rowData.id] : (expandedRows[rowData.id] = true);

                this.expandedRows = expandedRows;
            }
        },
    },
};
</script>

<style>
.p-paginator svg {
    width: 11px;
    height: 11px;
}

.p-paginator button,
.p-paginator .p-paginator-rpp-options,
.p-paginator .p-paginator-current {
    height: 30px;
}

.p-dropdown-item {
    font-size: 12px;
}

.p-paginator-bottom svg,
.p-paginator-current,
.paginatorwrapper .p-paginator-rpp-options span {
    color: #1878af !important;
}

.p-paginator-current {
    cursor: default;
}

.p-dropdown-item.p-highlight {
    background-color: #1878af !important;
}

.p-paginator .p-dropdown-label {
    font-size: 11px;
}

.p-paginator {
    justify-content: end !important;
    font-size: 11px;
}
</style>
<style scoped>
html {
    font-size: 12px;
}

.add-rule {
    border: 0;
    border-radius: 5px;
    background-color: #164B6C;
}

:deep(.p-paginator .p-highlight) {
    background-color: #164B6C !important;
}

.delete-icon {
    border: 0;
    font-size: 11px;
}

.icon {
    border: 0;
}

.italic {
    font-style: italic;
}

.modal {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    z-index: 1000000 !important;

    .w-75 {
        background: white;
        padding: 20px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    }
}
</style>
